import React from 'react';
import { SingleVideoItem } from '../../types/singleVideoType';
import closeImg from '../../img/close.png';
import './_modalCard.scss';

type modalCardProps = {
  card: SingleVideoItem;
};

const ModalCard: React.FC<modalCardProps> = (props) => {
  const { card } = props;
  const title = card.snippet.title;
  const description = card.snippet.description;
  const viewCount = card.statistics.viewCount;
  const likeCount = card.statistics.likeCount;
  const videoId = card.id;

  return (
    <React.Fragment>
      <div className="modalcard" data-id={videoId}>
        <div className="modalcard__img">
          <iframe
            width="480"
            height="360"
            src={`https://www.youtube.com/embed/${videoId}?autoplay=1`}
            frameBorder="0"
            allowFullScreen
          ></iframe>
        </div>
        <div className="modalcard__info">
          <h3 className="modalcard__title">{title}</h3>
          <p className="modalcard__description">{description}</p>
          <ul className="modalcard__props">
            <li className="modalcard__props-item">
              views: <span className="info__value">{viewCount}</span>
            </li>
            <li className="modalcard__props-item">
              likes: <span className="info__value">{likeCount}</span>
            </li>
          </ul>
        </div>
      </div>
      <div className="modalcard__close-button">
        <img className="close-button__img" src={closeImg} alt="close-img" />
      </div>
    </React.Fragment>
  );
};

export default ModalCard;
